import React from "react";
import { Link } from "react-router-dom";
import BlogImg3 from "../../assets/img/website-images/Blogdetailsbanner3.png";
import BlogImg2 from "../../assets/img/website-images/Blogdetailsbanner2.png";

function Main() {
  return (
    <>
      <footer
        className="footer-bg footer-p pt-90"
        style={{ backgroundColor: "#0C72BA" }}
      >
        <div className="footer-top pb-70">
          <div className="container">
            <div className="row justify-content-between">
              <div className="col-xl-3 col-lg-4 col-sm-6">
                <div className="footer-widget mb-30">
                  <div className="f-widget-title">
                    <h2>About Us</h2>
                  </div>
                  <div className="f-contact">
                    <p>
                      Akash Institute of Pharmacy (AIP) is a premier centre for pharmaceutical education under the Akash Group of Institutions.  Affiliated to Rajiv Gandhi University of Health Sciences (RGUHS) and recognized by Pharmacy council of India & approved by Government of Karnataka.
                    </p>
                  </div>
                  <div className="footer-social mt-10">
                    <a href="#">
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a href="#">
                      <i className="fab fa-instagram" />
                    </a>
                    <a href="#">
                      <i className="fab fa-twitter" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="offset-xl-1 col-xl-2 col-lg-2 col-sm-6">
                <div className="footer-widget mb-30">
                  <div className="f-widget-title">
                    <h2>Our Links</h2>
                  </div>
                  <div className="footer-link">
                    <ul>
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>
                        <Link to="/about-us">About Us</Link>
                      </li>
                      <li>
                        <Link to="/courses">Courses</Link>
                      </li>
                      <li>
                        <Link to="/blogs">News & Events</Link>
                      </li>
                      <li>
                        <Link to="/faculties">Faculties</Link>
                      </li>
                      <li>
                        <Link to="/contact-us"> Contact Us</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-sm-6">
                <div className="footer-widget mb-30">
                  <div className="f-widget-title">
                    <h2>Latest Post</h2>
                  </div>
                  <div className="recent-blog-footer">
                    <ul>
                      <li>
                        <div className="thum">
                          {" "}
                          <img src={BlogImg3} alt="img" />
                        </div>
                        <div className="text">
                          {" "}
                          <Link to="/blogs/top-career-opportunities-after-bpharm">
                            Top Career Opportunities After B.Pharm
                          </Link>
                          <span>
                            <b>10 March, 2025</b>
                          </span>
                        </div>
                      </li>
                      <li>
                        <div className="thum">
                          {" "}
                          <img src={BlogImg2} alt="img" />
                        </div>
                        <div className="text">
                          {" "}
                          <Link to="/blogs/why-practical-training-matters-in-pharmacy-education">
                            Why Practical Training Matters More Than...
                          </Link>
                          <span>
                            <b>18 March, 2025</b>
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-sm-6">
                <div className="footer-widget mb-30">
                  <div className="f-widget-title">
                    <h2>Contact Us</h2>
                  </div>
                  <div className="f-contact">
                    <ul>
                      <li>
                        <i className="icon fal fa-phone" />
                        <span>
                          <Link to="tel:+91 9986255343">+91 9986255343 <b>(Careers)</b></Link>
                          <br />
                          <Link to="tel:+91 9513107575">+91 9513107575 <b>(Admissions)</b></Link>
                        </span>
                      </li>
                      <li>
                        <i className="icon fal fa-envelope" />
                        <span>
                          <Link to="mailto:principal.akaship@yahoo.com">
                            principal.akaship@yahoo.com
                          </Link>
                          <br />
                          <Link to="mailto:akashpharma023@gmail.com">
                            akashpharma023@gmail.com
                          </Link>
                        </span>
                      </li>
                      <li>
                        <i className="icon fal fa-map-marker-check" />
                        <span>
                          <a
                            href="https://maps.app.goo.gl/dX7oRaQyfrqHSZ55A"
                            target="_blank"
                          >
                            Akash Institute of Pharmacy,<br/>
                            Prasannahalli Main Road,<br /> 
                            Devanahalli,<br /> 
                            Near International Airport,<br /> 
                            Bangalore - 562110
                          </a>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright-wrap">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-4">
                <div className="copy-text">
                  <Link to="/">
                    <img src="/assets/img/logo/aip-logo-white.png" alt="img" />
                  </Link>
                </div>
              </div>
              
              <div className="col-lg-8 text-right text-xl-right">
                © {new Date().getFullYear()} Akash Institute of Pharmacy. All Rights Reserved. | Powered by{" "}
                
                  Loftccess
                
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Main;
